"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const navItems = [
  { href: "/", label: "Accueil", icon: "home" },
  { href: "/history", label: "Historique", icon: "history" },
  { href: "/upload", label: "Nouveau", icon: "add_circle" },
  { href: "/profile", label: "Profil", icon: "person" },
];

export function BottomNav() {
  const pathname = usePathname();

  // Hide nav on pages where it doesn't belong
  if (
    pathname.startsWith("/processing") ||
    pathname.startsWith("/results") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/onboarding")
  ) {
    return null;
  }

  return (
    <nav className="bg-surface-container-lowest/95 border-outline-variant/20 fixed bottom-0 left-0 z-50 flex h-20 w-full items-center justify-around rounded-t-3xl border-t px-4 pb-[max(0.5rem,env(safe-area-inset-bottom))] shadow-[0_-4px_20px_rgba(28,28,25,0.05)] backdrop-blur-lg">
      {navItems.map((item) => {
        const active = pathname === item.href;
        return (
          <Link
            key={item.href}
            href={item.href}
            className={
              active
                ? "text-on-primary-fixed-variant bg-primary-fixed focus-visible:ring-primary/50 flex flex-col items-center justify-center rounded-xl px-3 py-1 font-bold focus-visible:ring-2 focus-visible:outline-none"
                : "text-on-surface-variant hover:text-primary focus-visible:ring-primary/50 flex flex-col items-center justify-center px-3 py-1 transition-colors focus-visible:ring-2 focus-visible:outline-none"
            }
          >
            <span
              className="material-symbols-outlined"
              style={active ? { fontVariationSettings: "'FILL' 1" } : undefined}
            >
              {item.icon}
            </span>
            <span className="mt-1 text-[11px] tracking-wider uppercase">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
